import { routes as home } from '../pages/home';
import { routes as moduleRoutes } from '../modules';
import Ambience from "@/pages/LoteProducao/Ambience/Ambience"

const GeoMortalidade = () => import(/* webpackChunkName: "group-geo" */'../pages/Geo/GeoMortalidade.vue')
const GeoAlojamento = () => import(/* webpackChunkName: "group-geo" */'../pages/Geo/GeoAlojamento.vue')
const GeoEstabelecimento = () => import(/* webpackChunkName: "group-geo" */'../pages/Geo/GeoEstabelecimento.vue')
const EstabelecimentoForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Estabelecimento/estabelecimentoForm.vue')
const EstabelecimentoSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Estabelecimento/estabelecimentoSearch.vue')
const TecnicoForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Tecnico/tecnicoForm.vue')
const TecnicoSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Tecnico/tecnicoSearch.vue')
const LaboratorioForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Laboratorio/laboratorioForm.vue')
const LaboratorioSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Laboratorio/laboratorioSearch.vue')
const PrincipioAtivoForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/PrincipioAtivo/principioAtivoForm.vue')
const PrincipioAtivoSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/PrincipioAtivo/principioAtivoSearch.vue')
const FabricaRacaoForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/FabricaRacao/fabricaRacaoForm.vue')
const FabricaRacaoSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/FabricaRacao/fabricaRacaoSearch.vue')
const PlantaAbateForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/PlantaAbate/plantaAbateForm.vue')
const PlantaAbateSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/PlantaAbate/plantaAbateSearch.vue')
const MotivoBaixaForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/MotivoBaixa/motivoBaixaForm.vue')
const MotivoBaixaSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/MotivoBaixa/motivoBaixaSearch.vue')
const LoteProducao = () => import(/* webpackChunkName: "group-cadastro" */'../pages/LoteProducao/loteProducao.vue')
const LoteProducaoAdmFarmaco = () => import(/* webpackChunkName: "group-batch" */'../pages/LoteProducao/admFarmaco.vue')
const LoteProducaoBaixa = () => import(/* webpackChunkName: "group-batch" */'../pages/LoteProducao/baixa.vue')
const LoteProducaoEntradaRacao = () => import(/* webpackChunkName: "group-batch" */'../pages/LoteProducao/entradaRacao.vue')
const LoteProducaoEntradaAnimais = () => import(/* webpackChunkName: "group-batch" */'../pages/LoteProducao/entradaAnimais.vue')
const LoteProducaoSaidaAnimais = () => import(/* webpackChunkName: "group-batch" */'../pages/LoteProducao/saidaAnimais.vue')
const LoteProducaoForm = () => import(/* webpackChunkName: "group-batch" */'../pages/LoteProducao/loteProducaoForm.vue')
const LoteProducaoInfos = () => import(/* webpackChunkName: "group-batch" */'../pages/LoteProducao/loteProducaoInfos.vue')
const LoteProducaoSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/LoteProducao/loteProducaoSearch.vue')
const LoteProducaoAmbiencia = () => import(/* webpackChunkName: "group-cadastro" */'../pages/LoteProducao/ambiencia.vue')
const FarmacoForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Farmaco/farmacoForm.vue')
const FarmacoSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Farmaco/farmacoSearch.vue')
const RacaoForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Racao/racaoForm.vue')
const RacaoSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Racao/racaoSearch.vue')
const TabelaConsumoRacaoForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/TabelaConsumoRacao/tabelaConsumoRacaoForm.vue')
const TabelaConsumoRacaoSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/TabelaConsumoRacao/tabelaConsumoRacaoSearch.vue')
const TabelaCrescimentoAnimal = () => import(/* webpackChunkName: "group-cadastro" */'../pages/TabelaCrescimentoAnimal/tabelaCrescimentoAnimal.vue')
const TabelaLimiteMortalidadeForm = () => import(/* webpackChunkName: "group-cadastro" */'../pages/TabelaLimiteMortalidade/tabelaLimiteMortalidadeForm.vue')
const TabelaLimiteMortalidadeSearch = () => import(/* webpackChunkName: "group-cadastro" */'../pages/TabelaLimiteMortalidade/tabelaLimiteMortalidadeSearch.vue')
const AnaliseMortalidadePeriodoFechamento = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Analise/analiseMortalidadePeriodoFechamento.vue')
const FeedConsumption = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Analise/FeedConsumption/FeedConsumption.vue')
const RelatorioPropriedadesAtivasView = () => import(/* webpackChunkName: "group-report" */ '../pages/Relatorio/RelatorioPropriedadesAtivas.vue')
const RelatorioAnimaisGerenciados = () => import(/* webpackChunkName: "group-report" */ '../pages/Relatorio/RelatorioAnimaisGerenciados.vue')
// const Mensagem =() => import (/* webpackChunkName: "group-cadastro" */'../pages/Mensagem/mensagem.vue')
// const HistoricoMensagens =() => import (/* webpackChunkName: "group-cadastro" */'../pages/Mensagem/historicoMensagens.vue')
const EnvioMensagensEstabelecimento = () => import(/* webpackChunkName: "group-cadastro" */'../pages/Mensagem/envioMensagensEstabelecimento.vue')

export default [
	...home,
	...moduleRoutes,
	{
		path: '/geoMortalidade',
		name: 'geoMortalidade',
		component: GeoMortalidade
	},
	{
		path: '/geoAlojamento',
		name: 'geoAlojamento',
		component: GeoAlojamento
	},
	{
		path: '/geoEstabelecimento',
		name: 'geoEstabelecimento',
		component: GeoEstabelecimento
	},
	{
		path: '/estabelecimento/:id?',
		name: 'estabelecimento',
		component: EstabelecimentoForm
	},
	{
		path: '/estabelecimentoSearch/',
		name: 'estabelecimentoSearch',
		component: EstabelecimentoSearch
	},
	{
		path: '/tecnico/:id?',
		name: 'tecnico',
		component: TecnicoForm
	},
	{
		path: '/tecnicoSearch/',
		name: 'tecnicoSearch',
		component: TecnicoSearch
	},
	{
		path: '/laboratorio/:id?',
		name: 'laboratorio',
		component: LaboratorioForm
	},
	{
		path: '/laboratorioSearch/',
		name: 'laboratorioSearch',
		component: LaboratorioSearch
	},
	{
		path: '/principioAtivo/:id?',
		name: 'principioAtivo',
		component: PrincipioAtivoForm
	},
	{
		path: '/principioAtivoSearch/',
		name: 'principioAtivoSearch',
		component: PrincipioAtivoSearch
	},
	{
		path: '/fabricaRacao/:id?',
		name: 'fabricaRacao',
		component: FabricaRacaoForm
	},
	{
		path: '/fabricaRacaoSearch/',
		name: 'fabricaRacaoSearch',
		component: FabricaRacaoSearch
	},
	{
		path: '/plantaAbate/:id?',
		name: 'plantaAbate',
		component: PlantaAbateForm
	},
	{
		path: '/plantaAbateSearch/',
		name: 'plantaAbateSearch',
		component: PlantaAbateSearch
	},
	{
		path: '/motivoBaixa/:id?',
		name: 'motivoBaixa',
		component: MotivoBaixaForm
	},
	{
		path: '/motivoBaixaSearch/',
		name: 'motivoBaixaSearch',
		component: MotivoBaixaSearch
	},
	{
		path: '/loteProducao/:id?',
		name: 'loteProducao',
		component: LoteProducao
	},
	{
		path: '/loteProducao/:idLote/admFarmaco/:id?',
		name: 'loteAdmFarmacos',
		component: LoteProducaoAdmFarmaco
	},
	{
		path: '/loteProducao/:idLote/baixa/:id?',
		name: 'loteBaixa',
		component: LoteProducaoBaixa
	},
	{
		path: '/loteProducao/:idLote/entradaRacao/:id?',
		name: 'loteEntradaRacao',
		component: LoteProducaoEntradaRacao
	},
	{
		path: '/loteProducao/:idLote/entradaAnimais/:id?',
		name: 'loteEntradaAnimais',
		component: LoteProducaoEntradaAnimais
	},
	{
		path: '/loteProducao/:idLote/saidaAnimais/:id?',
		name: 'loteSaidaAnimais',
		component: LoteProducaoSaidaAnimais
	},
	{
		path: '/loteProducaoInfos/:id?',
		name: 'loteProducaoInfos',
		component: LoteProducaoInfos
	},
	{
		path: '/loteProducaoForm/:id?',
		name: 'loteProducaoForm',
		component: LoteProducaoForm
	},
	{
		path: '/loteProducaoSearch/',
		name: 'loteProducaoSearch',
		component: LoteProducaoSearch
	},
	{
		path: '/loteProducaoAmbiencia/:ambienceDataType',
		name: 'loteProducaoAmbiencia',
		component: Ambience,
    props: true
	},
	{
		path: '/farmaco/:id?',
		name: 'farmaco',
		component: FarmacoForm
	},
	{
		path: '/farmacoSearch/',
		name: 'farmacoSearch',
		component: FarmacoSearch
	},
	{
		path: '/racao/:id?',
		name: 'racao',
		component: RacaoForm
	},
	{
		path: '/racaoSearch/',
		name: 'racaoSearch',
		component: RacaoSearch
	},
	{
		path: '/tabelaConsumoRacao/:id?',
		name: 'tabelaConsumoRacao',
		component: TabelaConsumoRacaoForm
	},
	{
		path: '/tabelaConsumoRacaoSearch/',
		name: 'tabelaConsumoRacaoSearch',
		component: TabelaConsumoRacaoSearch
	},
	{
		path: '/tabelaCrescimentoAnimal/',
		name: 'tabelaCrescimentoAnimal',
		component: TabelaCrescimentoAnimal
	},
	{
		path: '/tabelaLimiteMortalidade/:id?',
		name: 'tabelaLimiteMortalidade',
		component: TabelaLimiteMortalidadeForm
	},
	{
		path: '/tabelaLimiteMortalidadeSearch/',
		name: 'tabelaLimiteMortalidadeSearch',
		component: TabelaLimiteMortalidadeSearch
	},
	{
		path: '/analiseMortalidadePeriodoFechamento/',
		name: 'analiseMortalidadePeriodoFechamento',
		component: AnaliseMortalidadePeriodoFechamento
	},
	{
		path: '/analiseConsumoRacao/',
		name: 'analiseConsumoRacao',
		component: FeedConsumption
	},
	// {
	//     path: '/mensagem/:id?',
	//     name: 'mensagem',
	//     component: Mensagem
	// },
	// {
	//     path: '/historicoMensagens/',
	//     name: 'historicoMensagens',
	//     component: HistoricoMensagens
	// },
	{
		path: '/envioMensagem/',
		name: 'envioMensagem',
		component: EnvioMensagensEstabelecimento
	},
	{
		path: '/relatorioPropriedadesAtivas/',
		name: 'relatorioPropriedadesAtivas',
		component: RelatorioPropriedadesAtivasView,
	},
	{
		path: '/relatorioAnimaisGerenciados/',
		name: 'relatorioAnimaisGerenciados',
		component: RelatorioAnimaisGerenciados,
	},
	{
		path: '*',
		name: 'notFound',
		redirect: '/'
	},
]
